type DurationFormat = 'compact' | 'verbose'

/**
 * Format a duration in minutes to a human-readable string.
 *
 * @param totalMinutes - Duration in minutes
 * @param format - Output format:
 *   - `'compact'` (default): `"2h05"`, `"3h"`, `"Durée inconnue"`
 *   - `'verbose'`: `"2 H 05 min"`
 */
export function formatDuration(totalMinutes: number, format: DurationFormat = 'compact'): string {
  if (totalMinutes === 0) return 'Durée inconnue'

  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  if (format === 'verbose') {
    return `${hours} H ${String(minutes).padStart(2, '0')} min`
  }

  if (minutes === 0) return `${hours}h`
  return `${hours}h${minutes.toString().padStart(2, '0')}`
}
